import {
  Button,
  Image,
  Text,
  Box,
  Stat,
  StatHelpText,
  StatArrow,
  Input,
  Divider
} from "@chakra-ui/react";
import { useParams, useLocation  } from "react-router-dom";
import { useContext, useState } from "react";
import { BsDash, BsPlus } from 'react-icons/bs'
import { theme } from "../../styles/theme";
import swal  from 'sweetalert';
import { CartContext } from "../../Context/CartContext";
import { AddToCartPopUp } from "../AddToCartPopUp";
import { RiShoppingBasket2Line} from "react-icons/ri";
import { LazyLoadImage } from 'react-lazy-load-image-component';
export function ProductCard({
  product,
  id,
  name,
  brand,
  marketPrice,
  prices,
  batch,
  productPhotoUrl,
  suggestedPriceForSale,
  quantityPerBox,
  size,
  description,
  quantity_per_box,
  productType,
  carouselType
}) {

  const { id: productId } = useParams()
  const [quantity, setQuantity] = useState(1)
  const { showCartPopUp, setShowCartPopUp, handleSetSelectedProduct } = useContext(CartContext)
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  const { min, max } = (prices || []).reduce((acc, cur) => {
    if (cur.price_per_unity < acc.min) {
      acc.min = cur.price_per_unity;
    }
    if (cur.price_per_unity > acc.max) {
      acc.max = cur.price_per_unity;
    }
    return acc;
  }, { min: Infinity, max: -Infinity }) || {};


  const shareProductLink = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(e.target.dataset.copyText).then((error) => {
      swal({
        title: "👍",
        text: "Link copiado!",
        icon: "success",
      });
    })
  }

  function handleIncrement(e) {
    e.preventDefault()
    setQuantity(quantity + 1)
  }

  function handleDecrement(e) {
    e.preventDefault()
    if (quantity > 1) {
      setQuantity(quantity - 1)
    }
  }

  function finalPrice() {
    if (!id || prices?.length === 0) {
      return 0;
    }
    const sortedPrices = prices?.sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];
    for (let i = 0; i < sortedPrices.length; i++) {
      if (quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }
    const calculatedPrice = selectedPrice.price_per_unity * quantity * quantityPerBox;
    return calculatedPrice.toFixed(2);
  }


  const minUnity = prices.reduce((min, current) => (current.unity < min ? current.unity : min), prices[0]?.unity);
  return (<>
    <Box
      direction={{ base: 'column', sm: 'column' }}
      bg="white"
      borderRadius="16px"
      border="1px solid rgba(0, 74, 51, 0.08)"
      height="100%"
      // minHeight="420px"
      minHeight={{ base: "350px", md: "420px" }}
      width={{ base: '100%', md: '100%' }}
      marginBottom={{ base: '0', md: '0' }}
      display="flex"
      justifyContent="space-between"
      flexDirection="column"
      position="relative"
      transition="all 0.35s cubic-bezier(0.4, 0, 0.2, 1)"
      boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
      _hover={{
        transform: "translateY(-8px)",
        boxShadow: "0 12px 32px rgba(0, 74, 51, 0.16)",
        borderColor: "rgba(0, 74, 51, 0.16)"
      }}
    >
      {/* Image Container */}
      <Box position="relative" overflow="hidden" borderRadius="16px 16px 0 0" h={{ base: "120px", md: "160px" }}>
        <LazyLoadImage
          src={productPhotoUrl || require('../../assets/images/placeholder.webp')}
          alt='Boozen'
          effect="blur"
          style={{
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            backgroundPosition: "center",
          }}
          wrapperProps={{
            style: {transitionDelay: "1s", height: "100%"},
          }}
          loading="lazy"
          position="relative"
        />
        {carouselType === "Descontos" && (
          <Box
            position="absolute"
            top="12px"
            right="12px"
            bg={theme.colors.primaryOrange}
            borderRadius="999px"
            px="10px"
            py="4px"
            fontSize="12px"
            fontWeight="900"
            color="white"
            boxShadow="0 4px 12px rgba(252, 143, 4, 0.4)"
          >
            {batch.discount_per_centage}% OFF
          </Box>
        )}
      </Box>

      {/* Content Container */}
      <Box
        // padding="16px"
        padding={{ base: "10px", md: "16px" }}
        flex="1"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        gap="12px"
      >
        {/* Title and Brand */}
        <Box>
          <Text
            fontWeight='900'
            // fontSize="14px"
            fontSize={{ base: "13px", md: "14px" }}
            lineHeight="1.3"
            minH={{ base: "34px", md: "40px" }}
            color={theme.colors.primaryGreen}
            noOfLines={2}
            mb="4px"
          >
            {name}
          </Text>
          <Text
            fontWeight='600'
            // fontSize="12px"
            fontSize={{ base: "11px", md: "12px" }}
            color="rgba(18, 14, 11, 0.6)"
          >
            {brand}
          </Text>
        </Box>

        {/* Discount Badge and Original Price */}
        {batch && batch.discount_per_centage > 0 && (
          <Box display="flex" gap="8px" alignItems="center">
            <Box
              bg="rgba(252, 143, 4, 0.1)"
              border={`1px solid ${theme.colors.primaryOrange}`}
              borderRadius="6px"
              px="6px"
              py="3px"
            >
              <Text
                color={theme.colors.primaryOrange}
                fontWeight="900"
                fontSize="11px"
              >
                {batch.discount_per_centage}% OFF
              </Text>
            </Box>
            <Text
              fontWeight='600'
              // fontSize="12px"
              fontSize={{ base: "18px", md: "16px" }}
              textDecoration='line-through'
              color="rgba(18, 14, 11, 0.5)"
            >
              {marketPrice?.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
            </Text>
          </Box>
        )}

        {/* Price Range */}
        <Box>
          <Text
            fontSize="11px"
            fontWeight="600"
            color="rgba(18, 14, 11, 0.6)"
            mb="2px"
          >
            A partir de
          </Text>
          <Text
            color={theme.colors.primaryOrange}
            fontWeight='900'
            fontSize="16px"
          >
            {(min).toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}
          </Text>
        </Box>

        {/* Minimum Text */}
        <Text
          fontWeight='500'
          fontSize="11px"
          color="rgba(18, 14, 11, 0.5)"
        >
          Mín: {quantityPerBox * minUnity} {size ? <span>{size}{quantityPerBox > 1 && size ? "s" : ""}</span> : <span></span>}
        </Text>
      </Box>

      {/* Footer: Quantity and Action */}
      <Box px="16px" pb="16px" display="flex" flexDirection="column" gap="12px">
        {/* Quantity Selector */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          bg="rgba(0, 74, 51, 0.06)"
          border={`1.5px solid rgba(0, 74, 51, 0.12)`}
          borderRadius="999px"
          // h="36px"
          h={{ base: "32px", md: "36px" }}

          px="2px"
        >
          <Button
            size="sm"
            bg="transparent"
            color={theme.colors.primaryGreen}
            p="0"
            // minW="32px"
            // h="32px"
            minW={{ base: "28px", md: "32px" }}
            h={{ base: "28px", md: "32px" }}
            borderRadius="999px"
            _hover={{ bg: "rgba(0, 74, 51, 0.08)" }}
            onClick={(e) => handleDecrement(e)}
          >
            <BsDash size={18} />
          </Button>

          <Input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(parseInt(e.target.value))}
            readOnly={true}
            textAlign="center"
            border="none"
            bg="transparent"
            fontWeight="900"
            fontSize="14px"
            color={theme.colors.primaryGreen}
            width="40px"
            p="0"
            _focus={{ boxShadow: "none" }}
            cursor="default"
          />

          <Button
            size="sm"
            bg="transparent"
            color={theme.colors.primaryGreen}
            p="0"
            // minW="32px"
            // h="32px"
            minW={{ base: "28px", md: "32px" }}
            h={{ base: "28px", md: "32px" }}
            borderRadius="999px"
            _hover={{ bg: "rgba(0, 74, 51, 0.08)" }}
            onClick={(e) => handleIncrement(e)}
          >
            <BsPlus size={18} />
          </Button>
        </Box>
        <Box
          display="flex"
          flexDirection={{ base: "column", md: "row" }}
          gap={{ base: "8px", md: "10px" }}
          alignItems={{ base: "stretch", md: "center" }}
          justifyContent="space-between"
        >
          <Box display={{base: "flex", md: "block"}} gap={{base: "3px", md: ""}}>
            <Text
              fontSize="11px"
              fontWeight="600"
              color="rgba(18, 14, 11, 0.6)"
              mb="2px"
            >
              Total
            </Text>

            <Text
              color={theme.colors.primaryOrange}
              fontWeight="900"
              fontSize={{ base: "17px", md: "16px" }}
              lineHeight="1"
            >
              R$ {finalPrice()}
            </Text>
          </Box>

          <Button
            width={{ base: "100%", md: "auto" }}
            minW={{ md: "120px" }}
            bg={theme.colors.primaryGreen}
            color={theme.colors.primaryOrange}
            height={{ base: "34px", md: "36px" }}
            borderRadius="13px"
            fontWeight="900"
            fontSize={{ base: "12px", md: "13px" }}
            px={{ base: "12px", md: "16px" }}
            leftIcon={<RiShoppingBasket2Line />}
            transition="all 0.25s ease"
            _hover={{
              bg: theme.colors.primaryOrange,
              color: theme.colors.primaryGreen,
              transform: {
                base: "none",
                md: "translateY(-2px)"
              }
            }}
            _active={{
              transform: "scale(0.98)"
            }}
            onClick={(e) =>
              handleSetSelectedProduct(
                e,
                product,
                batch,
                finalPrice(),
                quantity
              )
            }
          >
            Adicionar
          </Button>
        </Box>
      </Box>
    </Box>
  </>)
}
